export const formatScore = (score?: number, maxScore: number = 1, usePercentage: boolean = true, decimals: number = 0) => {
  if (maxScore === 0 || score === undefined || score === null) return '-';
  if (usePercentage) {
    if (score <= 0) return '0%';
    const result = Math.min(100, (score / maxScore) * 100);
    return `${result.toFixed(decimals)}%`;
  }
  return `${score.toFixed(decimals)}`;
};
